import type { User } from '../../../types/interfaces';
import type { DiagnosticKind, DiagnosticTypeInfo } from '../../../types/diagnosticsInterfaces';

// Зеркало бэкенда: personal_area/views/permissions.py (_HD_STAFF_GROUPS, is_hd_admin,
// is_hd_lead_operator) и diagnostics/integration.py (can_create_remote). Именно эти
// группы бэк пускает к инструментам персонала (IsDiagnosticsStaff, lookup, результат);
// MANAGER/OFFICE_MANAGER/SALES_DIRECTOR и голый is_staff туда НЕ входят — раньше они
// видели кнопки инженера и получали 403.
const HD_STAFF_GROUPS = [
  'admins',
  'hd_lead_operator',
  'hd_operator',
  'managers',
  'HD_HEAD',
  'HD_ENGINEER',
  'HD_SERVICE_ENGINEER',
];
const HD_ADMIN_GROUPS = ['admins'];
const HD_LEAD_GROUPS = ['hd_lead_operator', 'HD_HEAD'];
const REMOTE_CREATE_GROUPS = [...HD_ADMIN_GROUPS, ...HD_LEAD_GROUPS, 'HD_ENGINEER'];

function inAny(me: User, groups: string[]): boolean {
  return (me.groups ?? []).some((g) => groups.includes(g));
}

export function isDiagnosticsStaff(me: User | null | undefined): boolean {
  if (!me) return false;
  return Boolean(me.is_superuser) || inAny(me, HD_STAFF_GROUPS);
}

/** Дистанционную диагностику создаёт тех. поддержка, руководитель ТП, админ или superuser. */
export function canCreateRemote(me: User | null | undefined): boolean {
  if (!me) return false;
  return Boolean(me.is_superuser) || inAny(me, REMOTE_CREATE_GROUPS);
}

/**
 * Перевод в финальный статус (diag_closed / remote_closed) бэк разрешает только
 * администратору или руководителю ТП (serializers/helpdesk.py: validate_status).
 * Остальному персоналу финальные статусы в выпадающем списке не показываем —
 * иначе выбор заканчивается ошибкой 400.
 */
export function canCloseDiagnostic(me: User | null | undefined): boolean {
  if (!me) return false;
  return Boolean(me.is_superuser) || inAny(me, [...HD_ADMIN_GROUPS, ...HD_LEAD_GROUPS]);
}

export function typeByKind(
  types: DiagnosticTypeInfo[],
  kind: DiagnosticKind,
): DiagnosticTypeInfo | undefined {
  return types.find((t) => t.kind === kind);
}

export function kindOfTicketType(
  types: DiagnosticTypeInfo[],
  ticketTypeId: number | null | undefined,
): DiagnosticKind | null {
  if (!ticketTypeId) return null;
  return types.find((t) => t.ticket_type.id === ticketTypeId)?.kind ?? null;
}

/** «б/н», если серийника нет. */
export const serialOrNone = (serial: string | null | undefined): string =>
  serial && serial.trim() ? serial : 'б/н';

export const formatDate = (iso: string | null | undefined): string => {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString('ru-RU');
};
